import {
  INVALIDATE_ALBUMS,
  REQUEST_ALBUMS,
  RECEIVE_ALBUMS,
  REQUEST_ALBUMS_SEARCH,
  RECEIVE_ALBUMS_SEARCH,
  RESET_ACTIVE_ALBUM,
  REQUEST_ALBUM,
  RECEIVE_ALBUM,
  INVALIDATE_REVIEWS,
  REQUEST_REVIEWS,
  RECEIVE_REVIEWS,
  RESET_ACTIVE_REVIEW,
  REQUEST_REVIEW,
  RECEIVE_REVIEW,
  INVALIDATE_PODCASTS,
  REQUEST_PODCASTS,
  RECEIVE_PODCASTS,
} from './actions'

export function albums(
  state = {
    pages: {},
    items: [],
    reviews: {},
    authors: {},
    search: { isFetching: false, didInvalidate: false, items: [] }
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_ALBUMS:
      return Object.assign({}, state, {
        pages: {
          ...state.pages,
          [action.page]: {
            ...state.pages[action.page],
            didInvalidate: true
          }
        }
      })
    case REQUEST_ALBUMS:
      return Object.assign({}, state, {
        pages: {
          ...state.pages,
          [action.page]: {
            ...state.pages[action.page],
            isFetching: true,
            didInvalidate: false
          }
        }
      })
    case RECEIVE_ALBUMS:
      return Object.assign({}, state, {
        pages: {
          ...state.pages,
          [action.page]: {
            ...state.pages[action.page],
            isFetching: false,
            didInvalidate: false,
            lastUpdated: action.receivedAt
          }
        },
        items: action.albums
      })
    case REQUEST_ALBUMS_SEARCH:
      return Object.assign({}, state, {
        search: {
          isFetching: true,
          didInvalidate: false,
          searchTerm: action.searchterm,
          items: []
        }
      })
    case RECEIVE_ALBUMS_SEARCH:
      return Object.assign({}, state, {
        search: {
          isFetching: false,
          didInvalidate: false,
          searchTerm: action.searchterm,
          items: action.albums
        }

      })
    case REQUEST_ALBUM:
      return Object.assign({}, state, {
        reviews: {
          ...state.reviews,
          active: action.id,
          [action.id]: {
            ...state.reviews[action.id],
            isFetching: true,
            didInvalidate: false
          }
        }
      })
    case RECEIVE_ALBUM:
      return Object.assign({}, state, {
        reviews: {
          ...state.reviews,
          [action.id]: {
            ...state.reviews[action.id],
            isFetching: false,
            didInvalidate: false,
            ...action.album
          }
        }
      })
    case RESET_ACTIVE_ALBUM:
      return Object.assign({}, state, {
        reviews: {
          ...state.reviews,
          active: null,
        }
      })
    default:
      return state
  }
}


export function reviews(
  state = {
    pages: {},
    items: [],
    reviews: {},
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_REVIEWS:
      return Object.assign({}, state, {
        pages: {
          ...state.pages,
          [action.page]: {
            ...state.pages[action.page],
            didInvalidate: true
          }
        }
      })
    case REQUEST_REVIEWS:
      return Object.assign({}, state, {
        pages: {
          ...state.pages,
          [action.page]: {
            ...state.pages[action.page],
            isFetching: true,
            didInvalidate: false
          }
        }
      })
    case RECEIVE_REVIEWS:
      return Object.assign({}, state, {
        pages: {
          ...state.pages,
          [action.page]: {
            ...state.pages[action.page],
            isFetching: false,
            didInvalidate: false,
            lastUpdated: action.receivedAt
          }
        },
        items: state.items.concat(action.reviews)
      })
    case REQUEST_REVIEW:
      return Object.assign({}, state, {
        reviews: {
          ...state.reviews,
          active: action.id,
          [action.id]: {
            ...state.reviews[action.id],
            isFetching: true,
            didInvalidate: false
          }
        }
      })
    case RECEIVE_REVIEW:
      return Object.assign({}, state, {
        reviews: {
          ...state.reviews,
          [action.id]: {
            ...state.reviews[action.id],
            isFetching: false,
            didInvalidate: false,
            ...action.review
          }
        }
      })
    case RESET_ACTIVE_REVIEW:
      return Object.assign({}, state, {
        reviews: {
          ...state.reviews,
          active: null,
        }
      })
    default:
      return state
  }
}


export function podcasts(
  state = {
    items: [],
    podcasts: {},
    pages: {}
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_PODCASTS:
      return Object.assign({}, state, {
        pages: {
          ...state.pages,
          [action.page]: {
            ...state.pages[action.page],
            didInvalidate: true
          }
        }
      })
    case REQUEST_PODCASTS:
      return Object.assign({}, state, {
        pages: {
          ...state.pages,
          [action.page]: {
            ...state.pages[action.page],
            isFetching: true,
            didInvalidate: false
          }
        }
      })
    case RECEIVE_PODCASTS:
      return Object.assign({}, state, {
        pages: {
          ...state.pages,
          [action.page]: {
            ...state.pages[action.page],
            isFetching: false,
            didInvalidate: false,
            lastUpdated: action.receivedAt
          }
        },
        items: state.items.concat(action.podcasts)
      })
    default:
      return state
  }
}
